import { render, staticRenderFns } from "./EmailValue.vue?vue&type=template&id=b0b6b1fa&scoped=true&"
import script from "./EmailValue.vue?vue&type=script&lang=js&"
export * from "./EmailValue.vue?vue&type=script&lang=js&"
import style0 from "./EmailValue.vue?vue&type=style&index=0&id=b0b6b1fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b6b1fa",
  null
  
)

export default component.exports